







import { createComponent, computed } from "@vue/composition-api";

interface BaseCheckbox {
  value: boolean;
  id: string;
  checkedText: string;
  uncheckedText: string;
}

export default createComponent({
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    },
    checkedText: {
      type: String,
      required: true
    },
    uncheckedText: {
      type: String,
      required: true
    }
  },
  setup(props: Readonly<BaseCheckbox>, { emit }) {
    const checked = computed({
      get: () => {
        return props.value;
      },
      set: val => {
        emit("input", val);
      }
    });

    const label = computed(() =>
      props.value ? props.checkedText : props.uncheckedText
    );

    return {
      checked,
      label
    };
  }
});
